<template>
  <div class="order-list tt-custom-tab single-income">
    <div v-if="mode==1" class="search-bar">
      <div>
        <el-select style="width:100%;" v-model="searchForm.merchant_id" clearable filterable
                   :filter-method="filterSearch"
                   class="input-width" placeholder="商家">
          <el-option v-for="(item,i) in businessOption"
                     :key="i" :label="item.merchant_name" :value="item.merchant_id"></el-option>

        </el-select>
      </div>
      <div>
        <el-select style="width:105px;" v-model="searchForm.fee_item_type_list" clearable filterable multiple
                   :popper-append-to-body="false"
                   class="input-width" placeholder="费用项目">
          <el-option v-for="(item,i) in fee_item_type_list" :key="i"
                     :label="item.content"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div>
        <el-select style="width:105px;" v-model="searchForm.bill_status" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="结算状态">
          <el-option v-for="(item,i) in bill_status_list" :key="i"
                     :label="item.content"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div>
        <el-input class="commbo-input" placeholder="收款用户" clearable v-model="searchForm.payee_user"
                  style="width:265px;">
          <el-select class="search-preix" v-model="buyer_type" slot="prepend" placeholder="请选择" style="width:120px;">
            <el-option label="收款用户" value="-1"></el-option>
          </el-select>
        </el-input>
      </div>
      <div>
        <Created
          :businessOption="merchants"
          :feeItemTypeList="fee_item_type_list"
          :calculatingMethodList="calculating_method_list"
          :calculatingMethodDetail="calculating_method_detail"
          :billStatusList="bill_status_list"
          :formData="formData1"
          v-on:success="search">
          <el-button id="amountBillButton" type="primary">新增账单</el-button>
        </Created>

      </div>
    </div>
    <div v-if="mode==1" class="search-bar seprator">
        <span>
            {{totalCount}}个账单&nbsp;&nbsp;
        </span>
      <div style="display:flex;align-items:center;">
        <div style="margin:0 5px;display: flex;align-items: center;">
          <el-select style="width:110px;" v-model="timeRangeType" class="combo-left mobile-select">
            <el-option label="创建时间" :value="1"></el-option>
            <!--<el-option label="更新时间" :value="2"></el-option>-->
          </el-select>
          <!--<el-select v-model="form.date" class="mobile-select" style="width:150px;margin-right:13px;">
            <el-option v-for="(date,index) in dateList" :key="index" :label="date" :value="date"></el-option>
          </el-select>-->
          <span class="combo-right">
                  <el-date-picker style="margin-right:5px;" format="yyyy-MM-dd HH:mm" v-model="timeRange"
                                  type="datetimerange" range-separator="至" start-placeholder="开始时间"
                                  end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']"
                                  @change="handleTimeChange">
                  </el-date-picker>
                </span>
        </div>
        <el-input class="commbo-input" style="width:460px;" placeholder="多个号码请用空格或逗号分隔" clearable v-model="searchWord">
          <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择" style="width:120px;">
            <el-option label="订单号" value="1"></el-option>
            <el-option label="任务号" value="2"></el-option>
            <el-option label="结算单号" value="3"></el-option>
          </el-select>
          <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
        </el-input>
        <!--<el-button style="width:70px;" v-show="mailList.filter(i=>i.isSelected).length" :loading="multipleUpdating" class="block btn-14" type="info" @click="updateMultipleMail()">批量更新</el-button>-->
      </div>
    </div>
    <div v-if="mode==1&&totalCount > 0" class="table">
      <div class="table-head">
        <div v-for="c in columns" :style="{width:c.width}">
          {{ c.name }}
        </div>
        <div style="opacity:0">
          <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="table-body pool">
        <el-collapse class="customCollapse2" v-model="activeName" accordion style="width:100%;"
                     @change="changeCollapse">
          <el-collapse-item v-for="(r,index) in dataList" :name="index" :key="index">
            <template slot="title">
              <div class="table-row-title" style="line-height:1;width:100%;">
                <!--                <div style="width: 40px;position: relative;top: -2px;color: #1aad19;">-->
                <!--                  <i style="font-size: 20px;" class="el-icon-truck"></i>-->
                <!--                </div>-->
                <div v-for="(c,idx) in columns" :key="idx" :style="{width:c.width}">
                  <template v-if="c.field=='create_time'">
                    <p style="font-size: 16px;padding-bottom: 5px;">{{ r.date_display }}</p>
                    <p style="color:#666;">{{ r.time_display }}</p>
                  </template>
                  <template v-if="c.field=='detail'">
                    <template>
                      <div v-html="handleBill(r)"></div>
                    </template>
                  </template>
                  <template v-if="c.field=='amount'">
                    <p class="padding-bottom-5" style="font-size: 16px;">{{r.amount}}{{r.currency}}</p>
                    <p class="text-gray">{{r.bill_status_content}}</p>
                  </template>
                </div>
              </div>
            </template>
            <div class="table-row-content">
              <!--<Mail :good_number="good_number" :r="r" :index="index" @updateMail="updateMail"></Mail>-->
              <BillCollapseBody :r="r" :index="index" :feeItemTypeList="fee_item_type_list"
                                v-on:updateBill="updateBill"></BillCollapseBody>
              <div style="clear:both;"></div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <!--结算-->

    <div v-if="mode==2" class="search-bar">
      <div>
        <el-select style="width:105px;" v-model="searchForm2.bill_settlement_status" clearable filterable
                   :popper-append-to-body="false"
                   class="input-width" placeholder="结算状态">
          <el-option v-for="(item,i) in bill_settlement_status_list" :key="i"
                     :label="item.content"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div>
        <CreateSettle
          :paymentMethodList="payment_method_list"
          v-on:success="search">
          <el-button type="primary">新增结算</el-button>
        </CreateSettle>
      </div>

    </div>
    <div v-if="mode==2" class="search-bar seprator">
        <span>
            {{totalCount}}个结算&nbsp;&nbsp;
        </span>
      <div style="display:flex;align-items:center;">
        <div style="margin:0 5px;display: flex;align-items: center;">
          <el-select style="width:110px;" v-model="timeRangeType" class="combo-left mobile-select">
            <el-option label="创建时间" :value="1"></el-option>
            <!--<el-option label="更新时间" :value="2"></el-option>-->
            <!--<el-option label="回复时间" :value="3"></el-option>-->
          </el-select>
          <span class="combo-right">
              <el-date-picker style="margin-right:5px;" format="yyyy-MM-dd HH:mm" v-model="timeRange"
                              type="datetimerange" range-separator="至" start-placeholder="开始时间"
                              end-placeholder="结束时间" :default-time="['00:00:00', '23:59:59']"
                              @change="handleTimeChange">
                  </el-date-picker>
          </span>
        </div>
        <el-input class="commbo-input" style="width:460px;" placeholder="多个号码请用空格或逗号分隔" clearable v-model="searchWord">
          <el-select class="search-preix" v-model="keyword_type" slot="prepend" placeholder="请选择" style="width:120px;">
            <el-option label="订单号" value="1"></el-option>
            <el-option label="任务号" value="2"></el-option>
            <el-option label="结算单号" value="3"></el-option>
          </el-select>
          <span style="cursor:pointer" @click="search()" slot="append">&nbsp;&nbsp;搜索&nbsp;&nbsp;</span>
        </el-input>
        <!--<el-button style="width:70px;" v-show="mailList.filter(i=>i.isSelected).length" :loading="multipleUpdating" class="block btn-14" type="info" @click="updateMultipleMail()">批量更新</el-button>-->
      </div>
    </div>
    <div v-if="mode==2&&totalCount > 0" class="table">
      <div class="table-head">
        <div v-for="c in columns2" :style="{width:c.width}">
          {{ c.name }}
        </div>
        <div style="opacity:0">
          <i class="el-collapse-item__arrow el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="table-body pool">
        <el-collapse class="customCollapse2" v-model="activeName" accordion style="width:100%;"
                     @change="changeCollapse">
          <el-collapse-item v-for="(r,index) in dataList" :name="index" :key="index">
            <template slot="title">
              <div class="table-row-title" style="line-height:1;width:100%;">
                <div v-for="(c,idx) in columns2" :key="idx" :style="{width:c.width}">
                  <template v-if="c.field=='create_time'">
                    <p style="font-size: 16px;padding-bottom: 5px;">{{ r.date_display }}</p>
                    <p style="color:#666;">{{ r.time_display }}</p>
                  </template>
                  <template v-if="c.field=='detail'">
                    <div v-html="handleSettle(r)"></div>

                  </template>
                  <template v-if="c.field=='amount'">
                    <p class="padding-bottom-5" style="font-size: 16px;">{{r.amount}}{{r.currency}}</p>
                    <p class="text-gray">{{r.bill_status_content}}</p>
                  </template>
                </div>
              </div>
            </template>
            <div class="table-row-content">
              <CollapseBody :r="r" :index="index" v-on:updateSettle="updateSettle"></CollapseBody>

              <div style="clear:both;"></div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>


    <div class="yd-pagination" v-if="totalCount / searchForm.limit > 1">
      <el-pagination :page-size="searchForm.limit" :pager-count="5" :current-page.sync="searchForm.page"
                     layout="prev, pager, next"
                     next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>

    <div v-if="!dataList" class="text-center">
      <Loading></Loading>
    </div>
  </div>

</template>

<script>
  import api from '../../../services/api.js'
  import Created from './Create'
  import CreateSettle from './CreateSettle'
  import CollapseBody from './CollapseBody'
  import BillCollapseBody from './BillCollapseBody'

  let _ = require('lodash')

  export default {
    name: 'cartList',
    components: {
      CollapseBody: CollapseBody,
      BillCollapseBody: BillCollapseBody,
      Created: Created,
      CreateSettle: CreateSettle

    },
    data() {
      return {
        timeRangeType: 1,
        buyer_type: '-1',
        currentSettle: {},
        customerOptions: {},
        formData1: {},
        mode: 1,
        bill_settlement_status_list: [],//结算状态
        bill_status_list: [],//账单状态
        calculating_method_list: [],//结算方式
        fee_item_type_list: [],//结算类型
        payment_method_list: [],//支付方式,
        calculating_method_detail: [{}],
        activeName: '',
        totalCount: 0,
        dataList: [],
        searchWord: '',
        keyword_type: '1',
        timeRange: [],
        selectAll: false,
        brandOption: [],
        sortOption: [{label: '创建时间', value: '1'}, {label: '添加用户数', value: '2'}],
        searchForm: {
          page: 1,
          limit: 10,
          fee_item_type_list: '',
          bill_status: '',
          merchant_id: '',
          payee_user: '',
        },
        searchForm2: {
          page: 1,
          limit: 10,
          bill_settlement_status: '',
          payee_user: '',
        },
        merchants: [],
        businessOption: [],
        columns: [
          {name: '创建时间', field: 'create_time', width: '20%'},
          {name: '账单详情', field: 'detail', width: 'calc(100% - 30%)'},
          {name: '金额', field: 'amount', width: '10%'},
        ],
        columns2: [
          {name: '创建时间', field: 'create_time', width: '20%'},
          {name: '结算详情', field: 'detail', width: 'calc(100% - 30%)'},
          {name: '金额', field: 'amount', width: '10%'},
        ],

        activeName: '0',
        searchWord: '',
        keyword_type: '1',

        searchForm: {
          express_company_id: '',
          account_id: '',
          transport_store_number: '',
          page: 1,
          limit: 10,
        },
        timeRange: [],
        companyOption: [],
        accountOption: [],
        dataList: [],
        totalCount: 0

      }
    },
    async mounted() {
      this.timeRange = [new Date(new Date().getTime() - 30 * 24 * 3600 * 1000), new Date()];
      this.timeRange = [new Date(new Date().getTime() - 30 * 24 * 3600 * 1000), new Date()];
      let res = await api.getConfig(this);
      Object.keys(res.body.result).map((item) => {
        this[item] = res.body.result[item]
      });
      let res2 = await api.getOrdersMerchants(this)
      this.merchants = res2.body.result;
      await this.search();


    },
    methods: {
      filterSearch(val) {
        this.businessOption = [];
        let mers = [];
        if (val) {
          mers = this.merchants.filter((item) => {
            return item.merchant_name.toLowerCase().indexOf(val.toLowerCase()) > -1
          })
        } else {
          mers = this.merchants;
        }
        this.businessOption = mers;
      },
      handleBill(r) {
        let noHtml;
        if (r.order_no_list && r.order_no_list.length === 1) {
          noHtml = `任务#${r.order_no_list[0]}`
        } else {
          noHtml = `${r.order_no_list.length}个任务`
        }
        let orderHtml;
        let merchant = this.merchants.find(i => i.merchant_id == r.merchant_order_info_list[0].merchant_id).merchant_name
        if (r.merchant_order_info_list && r.merchant_order_info_list.length === 1) {
          orderHtml = `${merchant}#${r.merchant_order_info_list[0].merchant_order_no}`
        } else {
          orderHtml = `${merchant}&nbsp;&nbsp;${r.merchant_order_info_list.length}个商家订单`
        }
        let html = `
                      <p style="font-size: 16px;padding-bottom: 5px;">${r.payee_user}#&nbsp;&nbsp;${r.bill_no}</p>

<p class="text-gray">
                        ${orderHtml}
                        ${noHtml}
                    </p>
`;
        return html;
      },
      handleSettle(r) {
        let text2 = r.bill_no_list.length == 1 ? r.bill_no_list[0] : r.bill_no_list.length + '个账单';
        let text3 = r.transaction_number;//交易单号
        let html = `<p style="font-size: 16px;fpadding-bottom: 5px;">
${r.payee_user}#&nbsp;&nbsp;${r.settlement_no}
<p class="text-gray">${text2}</p>
</p>`
        return html;
      },

      handleTimeChange() {
      },
      async updateBill(r) {
        let btn = document.getElementById('amountBillButton');
        this.formData1 = JSON.parse(JSON.stringify(r));
        btn.click();
      },
      async updateSettle(v) {
        let param = JSON.parse(JSON.stringify(this.currentSettle));
        param.bill_settlement_status = v;
        let res = await api.updateBillSettlement(this, param);
        if (res.body.status == 'ok') {
          this.$message.success('结算成功');
          this.search()
          return
        }

      },
      changeCollapse(i) {
        this.currentSettle = this.dataList[i]
      },
      handleTab(v) {
        console.log('----------------', v)
        this.mode = v;
        this.search()
      },
      search(obj) {
        const generateParams = () => {
          let params = {};
          if (this.timeRange && this.timeRange.length) {
            params.start_time = this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
            params.end_time = this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
          }
          params.limit = this.searchForm.limit;
          params.page = this.searchForm.page;
          if (this.mode == 1) {
            for (let p in this.searchForm) {
              if (this.searchForm[p])
                params[p] = this.searchForm[p]
            }
          } else {
            for (let p in this.searchForm2) {
              if (this.searchForm2[p])
                params[p] = this.searchForm2[p]
            }
          }

          if (this.searchWord) {
            if (this.mode == 1) {
              let key = {'1': 'merchant_order_no', '2': 'order_no', '3': 'payee_user'};
              let temp
              for (let i in key) {
                if (i == this.keyword_type) {
                  temp = key[i];
                  params[key[i]] = this.searchWord
                  break;
                }
              }
            } else {
              let key = {'1': 'payee_user',};
              let temp
              for (let i in key) {
                if (i == this.keyword_type) {
                  temp = key[i];
                  params[key[i]] = this.searchWord
                  break;
                }
              }
            }

          }
          return params
        }
        let params = generateParams();
        this.getList(params)
      },
      async getList(params) {
        this.activeName = [];
        this.dataList = null;
        this.totalCount = null;
        if (this.mode == 1) {
          let res = await api.getBillList(this, params);
          this.dataList = res.body.result.map(item => {
            if (item.create_time) {
              item.date_display = this.generateDateDisplay(item.create_time.split(' ')[0])
              item.time_display = item.create_time.split(' ')[1]
            }
            if (item.update_time) {
              item.date_display2 = this.generateDateDisplay(item.update_time.split(' ')[0])
              item.time_display2 = item.update_time.split(' ')[1]
            }
            return item;
          });
          let res2 = await api.countBillList(this, params);
          this.totalCount = +res2.body.result;
        } else {
          let res = await api.getBillSettlementList(this, params);
          let res2 = await api.countBillSettlementList(this, params);
          this.dataList = res.body.result.map(item => {
            if (!item.bill_id_list) {
              item.bill_id_list = [];
            }
            if (item.create_time) {
              item.date_display = this.generateDateDisplay(item.create_time.split(' ')[0])
              item.time_display = item.create_time.split(' ')[1]
            }
            if (item.update_time) {
              item.date_display2 = this.generateDateDisplay(item.update_time.split(' ')[0])
              item.time_display2 = item.update_time.split(' ')[1]
            }
            return item;
          });
          this.totalCount = +res2.body.result;
        }
      },
      generateDateDisplay(datestring) {
        let today = new Date()
        let yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
        let today_string = this.$moment(today).format('YYYY-MM-DD')
        let yest_string = this.$moment(yesterday).format('YYYY-MM-DD')
        if (datestring == today_string)
          return '今天';
        if (datestring == yest_string)
          return '昨天';
        return datestring
      },
      // evalPrice(r) {
      //   if (r.transport_amount_currency == r.tax_amount_currency) {
      //     let a = isNaN(Number(r.transport_amount)) ? 0.00 : Number(r.transport_amount);
      //     let b = isNaN(Number(r.tax_amount)) ? 0.00 : Number(r.tax_amount);
      //     let c = r.html.items_price;
      //     let num = this.$decimalFormat((a + b + c), 2);
      //     if (isNaN(num)) {
      //       num = 0.00
      //     }
      //     let symbol = '';
      //     if (r.transport_amount_currency === 'CAD') {
      //       symbol = 'C$';
      //     }
      //     return symbol + num + r.transport_amount_currency;
      //   }
      //   return '--';
      // },
      // generateDateDisplay(datestring) {
      //   let today = new Date()
      //   let yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
      //   let today_string = this.$moment(today).format('YYYY-MM-DD')
      //   let yest_string = this.$moment(yesterday).format('YYYY-MM-DD')
      //   if (datestring == today_string)
      //     return '今天';
      //   if (datestring == yest_string)
      //     return '昨天';
      //   return datestring
      // },
      // async changeCollapse(val) {
      //
      // },
      // search() {
      //   const generateParams = () => {
      //     let params = {};
      //     if (this.timeRange && this.timeRange.length) {
      //       params.create_time_from = this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm:ss')
      //       params.create_time_to = this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm:ss')
      //     }
      //     params.limit = this.searchForm.limit;
      //     params.page = this.searchForm.page;
      //
      //     for (let p in this.searchForm) {
      //       if (this.searchForm[p])
      //         params[p] = this.searchForm[p]
      //     }
      //
      //     if (this.searchWord) {
      //       switch (this.keyword_type) {
      //         case '1':
      //           params.keyword = this.searchWord;
      //           break;
      //         case '2':
      //           params.tracking_number = this.searchWord;
      //           break;
      //         case '3':
      //           params.merchant_order_number = this.searchWord;
      //           break;
      //       }
      //     }
      //     return params
      //   }
      //   let params = generateParams();
      //   this.getList(params)
      // },
      // async changeCompany(val) {
      //   let res = await api.getZhuanyunAccountListByExpressCompany(this, {express_company_id: val});
      //   this.accountOption = res.body.result;
      // },
      // async getList(params) {
      //   function evalWeight(r) {
      //     let weight, real;
      //     weight = isNaN(r.weight_value) ? '--' : r.weight_value + r.weight_unit;
      //     real = isNaN(r.weight_value_real) ? '--' : r.weight_value_real + r.weight_unit_real;
      //     let arr = [{name: '包裹重量', value: weight}, {name: '收费重量', value: real}]
      //     return arr.filter(x => x.value != '--');
      //   }
      //
      //   function evalMoney(r) {
      //     // {{ r.transport_amount }}{{r.transport_amount_currency}}| {{ r.tax_amount }}{{r.tax_amount_currency}}
      //     let tr, tx;
      //     tr = !r.transport_amount || isNaN(r.transport_amount) ? '--' : r.transport_amount + r.transport_amount_currency
      //     tx = !r.tax_amount || isNaN(r.tax_amount) ? '--' : r.tax_amount + r.tax_amount_currency
      //     let arr = [{name: '运费', value: tr}, {name: '税费', value: tx}]
      //     return arr.filter(x => x.value != '--');
      //   }
      //
      //   let res = await api.getOutboundDetailList(this, params)
      //   let resCount = await api.countOutboundDetailList(this, params);
      //   this.totalCount = +resCount.body.result;
      //   this.dataList = res.body.result.map(item => {
      //     if (item.create_time) {
      //       item.date_display = this.generateDateDisplay(item.create_time.split(' ')[0])
      //       item.time_display = item.create_time.split(' ')[1]
      //       try {
      //         item.html = JSON.parse(item.html);
      //       } catch (e) {
      //         //不是json字符串不处理
      //       }
      //     }
      //     item.weight_label = evalWeight(item);
      //     item.money_label = evalMoney(item);
      //     return item;
      //   });
      // },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .empty-content {
    padding: 50px 0 50px;
  }
</style>

<style lang="scss">
  .order-list {
    margin-bottom: 80px;

    .el-tabs__content {
      overflow: visible;
    }
  }

  .search-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    &.seprator {
      justify-content: space-between;
    }
  }

  .table {
    margin-top: 43px;
    overflow-x: auto;
    overflow-y: hidden;

    .table-head,
    .table-body {
      display: flex;
    }

    .table-head {
      padding: 18px 11px 18px 21px;
      border-left: 2px solid transparent;
      border-right: 2px solid transparent;
    }

    .table-row-title {
      display: flex;
    }

    .table-head {
      color: #333;
    }

    .seporater-order {
      padding: 0 50px;
      height: 40px;
      border: 1px solid #D7D7D7;
      border-top: none;
      line-height: 40px;
    }

    .table-row-content {
      //display:flex;
      padding: 25px 50px 30px;
      border: 1px solid #D7D7D7;
      border-top: none;

      &.order {
        display: block;
        border-top: 1px solid #D7D7D7;
      }
    }

    .table-row-seperator {
      float: left;
      height: 33px;
      width: 100%;
      border-left: 1pX dashed #D7D7D7;
      border-right: 1px dashed #D7D7D7;
    }
  }

  .yd-pagination {
    margin-top: 30px;
  }

  .redirct {
    font-size: 24px;
    line-height: 33px;
    margin-top: 54px;
    padding-bottom: 70px;

    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }

    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }
</style>
<style scoped lang="scss">
  .single-income {
    padding: 0 35px 60px;

    .total {
      .block {
        width: 108px;
        margin-top: 15px;
        margin-bottom: 50px;
      }

      span {
        font-size: 14px;
        color: #333;
        line-height: 26px;
      }

      p {
        font-size: 33px;
        color: #666;
      }
    }

    .header {
      color: #333;
    }

    .list {
      .el-row {
        padding: 0 18px 18px;
        border-bottom: 1px solid #EBEBEB;
        margin-bottom: 18px;
      }

      p {
        font-size: 16px;
        padding-bottom: 5px;
      }

      span {
        color: #666;
      }

      .payInfo {
        font-size: 16px;
        line-height: 26px;
      }
    }

  }

  @media screen and (max-width: 1024px) {
    .single-income {
      padding: 0 0 60px;

      .list {

        .el-row {
          padding: 0 0 18px;
        }

        p {
          line-height: 20px;

        }
      }

      .total {
        .el-row {
          display: inline-block;
        }

        p {
          font-size: 18px;
        }

        .block {
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/amount_bill/List2.vue